export const BRAND_NAME = process.env.NEXT_PUBLIC_BRAND_NAME ?? ''
const PREFIX = BRAND_NAME ? `${BRAND_NAME}/` : ''

export const HOME_PAGE = `${PREFIX}homepage`

export const MEGA_MENU_ID = {
  MAIN_NAV: `${PREFIX}mega-menu-nav`,
  FOOTER: `${PREFIX}mega-menu-footer`,
} as const
